import { render, staticRenderFns } from "./Hierarchies.vue?vue&type=template&id=4ad9ad12&"
import script from "./Hierarchies.vue?vue&type=script&lang=js&"
export * from "./Hierarchies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QBreadcrumbs,QBreadcrumbsEl,QBtn,QCard,QCardSection,QTabs,QTab,QSeparator,QTabPanels,QTabPanel} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QBreadcrumbs,QBreadcrumbsEl,QBtn,QCard,QCardSection,QTabs,QTab,QSeparator,QTabPanels,QTabPanel})
